import { render, staticRenderFns } from "./m_home.vue?vue&type=template&id=f771f84c&scoped=true&"
import script from "./m_home.vue?vue&type=script&lang=js&"
export * from "./m_home.vue?vue&type=script&lang=js&"
import style0 from "./m_home.vue?vue&type=style&index=0&id=f771f84c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f771f84c",
  null
  
)

export default component.exports